import {useEffect} from "react";

export const useKeyDownListener = (onKeyDown: (key: string) => void) => {
	useEffect(() => {
		const handleKeyDown = (event: KeyboardEvent) => {
			onKeyDown(event.key)
		}

		document.addEventListener("keydown", handleKeyDown);
		return () => {
			document.removeEventListener("keydown", handleKeyDown);
		};
	}, [onKeyDown]);
}